import instance from '@/api/instance'
import { iRegion } from '@/types/responses'

export const loadRegions = () => instance.get<iRegion[]>('regions/index')
